import React, { useState } from "react";
import { Field } from "formik";
import {
  CsplTable as Table,
  FieldInput,
  FieldInputPercentage,
  AddPlans,
  SliderPanel,
  Link,
  FormControlSearch,
  WarningModal,
} from "../../../components";
import { get, isEmpty } from "lodash";
import { useDeepEffect } from "../../../abstracts";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { setValue } from "@microsoft/applicationinsights-core-js";

const columns = [
  {
    label: "Investment",
    className: "column-investment",
    columnName: "investmentName",
  },
  {
    label: "Percentage",
    className: "column-percentage",
    columnName: "percentage",
  },
  {
    label: "Action",
    className: "column-action",
    columnName: "action",
  },
];

export const DifferentSourceElectionnSamePartcipantElection = (props) => {
  const {
    fields,
    isSave,
    isEdit,
    values,
    setFieldValue,
    setValues,
    handleChange,
    investmentList,
    sourcesList,
    setToggle,
    toggle,
    handleSubmit,
    autoEnrollment,
    deleteInvestment,
    planId,
    errors,
  } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const [sourceIndex, setSourceIndex] = useState();
  const [filteredResponse, setFilteredResponse] = useState({});
  const [addedInvestments, setAddedInvestments] = useState({
    ...get(values, "autoEnrollment.savedInvestments", {}),
  });
  const [searchString, setSearchString] = useState("");
  // let saveInvestments = get(values, "autoEnrollment.savedInvestments", {});
  const [modalVisible, setModalVisible] = useState(false);
  const addInvestmentsToPlan = (investment) => {
    setAddedInvestments({
      ...addedInvestments,
      [sourceIndex]: [...(addedInvestments[sourceIndex] || []), investment],
    });
  };
  const onViewButtonClick = (index) => {
    setModalOpen(true);
    setSourceIndex(index);
  };
  {
    console.log("added", addedInvestments);
  }
  const onSubmit = (savedInvestments) => {
    values["autoEnrollment"]["savedInvestments"] = {
      ...get(values, "autoEnrollment.savedInvestments", {}),
      [sourceIndex]: savedInvestments,
    };
    setValues(values);
    // setFieldValue("autoEnrollment.savedInvestments", {
    //   ...get(values, "autoEnrollment.savedInvestments", {}),
    //   [sourceIndex]: savedInvestments,
    // });
    setModalOpen(false);
  };
  const onCancel = () => {
    if (
      addedInvestments?.[sourceIndex]?.length !=
      get(values, `autoEnrollment.savedInvestments.${sourceIndex}`, []).length
    ) {
      setModalVisible(true);
    } else {
      setModalOpen(false);
    }
  };
  {
    console.log("vall", values);
  }
  const modalOnCancel = () => {
    setAddedInvestments({
      ...addedInvestments,
      [sourceIndex]: values["autoEnrollment"]["savedInvestments"][sourceIndex],
    });
    setModalOpen(false);
    setModalVisible(false);
  };

  useDeepEffect(() => {
    (sourceIndex || sourceIndex == 0) &&
      setFilteredResponse({
        ...filteredResponse,
        [sourceIndex]: investmentList.filter((team) => {
          return team.investmentName
            .toLowerCase()
            .includes(searchString.toLowerCase());
        }),
      });
  }, [searchString, investmentList, sourceIndex]);

  const deletefunction = (name, index, ind) => {
    var temp = values["autoEnrollment"]["savedInvestments"][index].filter(
      (e) => e.investmentName !== name
    );
    setAddedInvestments({ ...addedInvestments, [index]: temp });
    //const tempValues = { ...values };
    values["autoEnrollment"]["savedInvestments"][index] = temp;
    values["autoEnrollment"]["autoEnrollmentSouceInvestmentElections"][
      index
    ] = temp;
    // tempValues.autoEnrollment.autoEnrollmentSouceInvestmentElections[
    //   index
    // ] = get(
    //   values,
    //   `autoEnrollment.autoEnrollmentSouceInvestmentElections.${index}`,
    //   []
    // )?.filter((x) => x.investmentName !== name);
    setValues({ ...values });
    // setFieldValue(`autoEnrollment.savedInvestments.${index}`, temp);
    // let temp2 = get(values, `autoEnrollment.autoEnrollmentSouceInvestmentElections.${index}`, []).filter((_, i) => i !== ind);
    // setFieldValue(`autoEnrollment.autoEnrollmentSouceInvestmentElections.${index}`, temp2);
  };
  const onDeleteClick = (name, index, ind) => {
    // setToggle(!toggle);
    deletefunction(name, index, ind);
  };

  const Invsum = (index) => {
    let sum1 = 0;
    if (
      !isEmpty(
        values.autoEnrollment.autoEnrollmentSouceInvestmentElections[index]
      )
    )
      values.autoEnrollment.autoEnrollmentSouceInvestmentElections[index].map(
        (x) => (sum1 = sum1 + x?.investmentPercentage)
      );
    return sum1;
  };
  const errorMsg = (invsum) =>
    invsum !== 100
      ? "The total value of investment election should not exceed or subceed 100%"
      : "";
  const AddName = (e, source, index, ind, sName, sId) => {
    if (
      !isEmpty(
        values.autoEnrollment.autoEnrollmentSouceInvestmentElections[index]
      ) &&
      !isEmpty(
        values.autoEnrollment.autoEnrollmentSouceInvestmentElections[index][ind]
      )
    ) {
      //if(!isEmpty(values.autoEnrollment.autoEnrollmentSouceInvestmentElections[index].investmentElection[ind])){
      values.autoEnrollment.autoEnrollmentSouceInvestmentElections[index][
        ind
      ].investmentName = source;
      values.autoEnrollment.autoEnrollmentSouceInvestmentElections[index][
        ind
      ].sourceName = sName;
      values.autoEnrollment.autoEnrollmentSouceInvestmentElections[index][
        ind
      ].sourceId = sId;
      // }
    }
    handleChange(e);
  };
  const investmentListLength = (filteredResponse[sourceIndex] || []).length;
  return (
    <div>
      <p className="mt-20 plan-heading-plan">List of sources</p>
      {(sourcesList || []).map((source, index) => {
        const sliderPanel = (
          <SliderPanel isOpen={isModalOpen} size="35" showCancel={false}>
            <div className="inside-content">
              <div className="d-flex justify-content-between align-baseline">
                <div>
                  <p className="investment-heading">Plan Investments</p>
                  <p className="investment-sub-heading">
                    {investmentListLength}{" "}
                    {investmentListLength === 1
                      ? "Investment Available"
                      : "Investments Available"}
                  </p>
                </div>
                <div>
                  <Button variant="secondary" onClick={() => onCancel()}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => onSubmit(addedInvestments[sourceIndex])}
                    className="ml-4"
                  >
                    Save
                  </Button>
                </div>
              </div>
              <div className="search-bar-investment">
                <Form>
                  <InputGroup>
                    <FormControlSearch
                      size="lg"
                      id="plan-search-box"
                      className="plan-search-box"
                      type="search"
                      autoComplete="off"
                      placeholder="Search Investment"
                      onChange={(e) => setSearchString(e.target.value)}
                    />
                    {/* <InputGroup.Append>
                      <InputGroup.Text className="plan-search-button">
                        <Image
                          src="/assets/icons/svg/search.svg"
                          width="14px"
                        />
                      </InputGroup.Text>
                    </InputGroup.Append> */}
                  </InputGroup>
                </Form>
              </div>
              <div className="d-flex content-end">
                <p className="investment-side-content">
                  {(filteredResponse[sourceIndex] || []).length} Investments
                  Available
                </p>
              </div>
              {console.log(
                "jjj",
                addedInvestments[sourceIndex],
                filteredResponse[sourceIndex]
              )}
              <div className="scroll-body">
                {filteredResponse[sourceIndex] &&
                  (filteredResponse[sourceIndex] || []).map((e, i) => (
                    <div className="d-flex justify-content-between">
                      <p>{e.investmentName}</p>
                      {(addedInvestments[sourceIndex] || []).find(
                        (y) => y.investmentName === e.investmentName
                      ) ? (
                        // <Button
                        //   size="sm"
                        //   style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                        //   variant="secondary"
                        //   disabled
                        //   classname="custom-added"
                        // >
                        //   Added
                        // </Button>

                        <div className="added-button-inside">
                          <div className="added-button-inner-text">Added</div>
                        </div>
                      ) : (
                        <>
                          {/* <Button
                          style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                          variant="secondary"
                          onClick={() => addInvestmentsToPlan(e)}
                        >
                          Add
                        </Button> */}
                          <div
                            className="add-button-inside"
                            onClick={() => addInvestmentsToPlan(e)}
                          >
                            <div className="add-button-inner-text">Add</div>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </SliderPanel>
        );
        if (
          get(
            values,
            `autoEnrollment.savedInvestments.${index}.0.investmentName`
          ) != null
          //!isEmpty(autoEnrollment.autoEnrollmentSouceInvestmentElections)
        ) {
          return (
            <div>
              <div className="mt-40 table-size">
                <div className="d-flex justify-content-between align-baseline">
                  <p className="mt-20 plan-heading-plan">{source.sourceName}</p>
                  <Button
                    variant="secondary"
                    disabled={isEdit && !isSave}
                    onClick={() => {
                      setModalOpen(true);
                      setSourceIndex(index);
                    }}
                  >
                    Add Investment
                  </Button>
                </div>
                <div>
                  <Table>
                    <Table.Thead>
                      <Table.Tr>
                        {columns.map((item, index) => {
                          return (
                            <Table.Th
                              key={index}
                              className={(item.className, "col-md-4")}
                            >
                              {item.label}
                            </Table.Th>
                          );
                        })}
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {(
                        values["autoEnrollment"]["savedInvestments"][index] ||
                        []
                      ).map((investment, ind) => {
                        const fieldName = `autoEnrollment.autoEnrollmentSouceInvestmentElections[${index}][${ind}].investmentPercentage`;

                        return (
                          <Table.Tr key={ind}>
                            <Table.Td className="column-investment col-md-4">
                              {investment.investmentName}
                            </Table.Td>
                            <Table.Td className="column-percentage">
                              <Form
                                autoComplete="off"
                                className="h-100 percentage-field"
                              >
                                <Field
                                  size="xs"
                                  isRequired
                                  name={fieldName}
                                  hasSuggestion
                                  shouldDisplaySuggestion
                                  component={FieldInputPercentage}
                                  type="number"
                                  value={get(values, fieldName)}
                                  onChange={(e) => {
                                    AddName(
                                      e,
                                      investment.investmentName,
                                      index,
                                      ind,
                                      source.sourceName,
                                      source.sourceId
                                    );
                                  }}
                                  disabled={isEdit && !isSave}
                                  autoComplete="off"
                                  validate={(value) => {
                                    return value === null ||
                                      value === undefined ||
                                      value === ""
                                      ? "PL545 : Required"
                                      : value === 0
                                      ? "PL546 : Allocation percentage cannot be 0"
                                      : undefined;
                                  }}
                                />
                              </Form>
                            </Table.Td>
                            <Table.Td className="column-action col-md-4">
                              <Link>
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  color="red"
                                  onClick={() => {
                                    if (!(isEdit && !isSave))
                                      onDeleteClick(
                                        investment.investmentName,
                                        index,
                                        ind
                                      );
                                  }}
                                />
                              </Link>
                            </Table.Td>
                          </Table.Tr>
                        );
                      })}
                    </Table.Tbody>
                    <div className="line-separator-total" />
                    <Table.Tbody>
                      <Table.Tr>
                        <Table.Td className="column-investment col-md-4">
                          Total
                        </Table.Td>
                        <Table.Td className="column-percentage col-md-4">
                          {/* <Form
                            autoComplete="off"
                            className="h-100 percentage-field"
                          > */}
                          <Field
                            size="xs"
                            isRequired
                            name="totalBox"
                            hasSuggestion
                            shouldDisplaySuggestion
                            component={FieldInputPercentage}
                            type="number"
                            value={Invsum(index)}
                            autoComplete="off"
                            disabled
                          />
                          <div
                            style={{
                              display: "block",
                              color: "#ff5050",
                              fontSize: "0.75rem",
                              marginTop: "0rem",
                            }}
                          >
                            {errorMsg(Invsum(index))}
                          </div>
                          {/* </Form> */}
                        </Table.Td>
                      </Table.Tr>
                    </Table.Tbody>
                  </Table>
                </div>
              </div>
              {sliderPanel}
            </div>
          );
        } else {
          return (
            <div>
              <div className="mt-40">
                <p className="mt-20 plan-heading-plan">{source.sourceName}</p>
                <AddPlans
                  content="No Investments added."
                  buttonLabel="Add Investment"
                  disabled={isEdit && !isSave}
                  onPrimaryClick={() => onViewButtonClick(index)}
                />
                <p
                  style={{
                    display: "block",
                    color: "#ff5050",
                    fontSize: "0.75rem",
                    marginTop: "0rem",
                  }}
                >
                  {get(
                    errors,
                    "autoEnrollment.investmentElectionDiffSourceSameParticipant",
                    ""
                  )}
                </p>
              </div>
              {sliderPanel}
            </div>
          );
        }
      })}
      <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>Your changes may be lost. Do you want to continue ?</p>
          <Button
            type="button"
            className="remove-btn mr-4"
            onClick={() => modalOnCancel()}
          >
            Yes
          </Button>
          <Button className="cancel-btn" onClick={() => setModalVisible(false)}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};

export default DifferentSourceElectionnSamePartcipantElection;
